import { render } from "./factory_stock_detail.vue?vue&type=template&id=5cc0b3a4&scoped=true"
import script from "./factory_stock_detail.vue?vue&type=script&lang=js"
export * from "./factory_stock_detail.vue?vue&type=script&lang=js"

import "./factory_stock_detail.vue?vue&type=style&index=0&id=5cc0b3a4&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc0b3a4"]])

export default __exports__